import { render, staticRenderFns } from "./payPoster.vue?vue&type=template&id=ffb28ab6&scoped=true"
import script from "./payPoster.vue?vue&type=script&lang=js"
export * from "./payPoster.vue?vue&type=script&lang=js"
import style0 from "./payPoster.vue?vue&type=style&index=0&id=ffb28ab6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffb28ab6",
  null
  
)

export default component.exports